import { capitalize, styled } from '@mui/material'
import Tag from 'features/common/ui/Tag'

const Type = styled(Tag)(({ theme }) => ({
  '.Mui-selected &, [aria-selected="true"] &': {
    '& .MuiTypography-root': {
      color: theme.palette.primary.main
    }
  }
}))

function TypeTag({ type }: { type: string }) {
  return (
    <Type
      label={capitalize(type.toLowerCase())}
      variant="outlined"
      color="default"
      typographyProps={{
        variant: 'code3',
        weight: 'strong'
      }}
    />
  )
}

export default TypeTag
